import { useUserIdentityContext } from "@core/services/user-identity.context";
import {
  GetResponseSplashScreenModel,
  GetSplashScreenModel,
} from "@factory/model/query-model-splash-screen";
import { viewAsset } from "@factory/query/google-cloud-storage.query";
import { useQyGetSplashScreen } from "@factory/query/splash-screen.query";
import StorageService from "@shared/services/storage.service";
import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import useScreenSize from "@shared/utility/screen-size";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { TabMenu, TabMenuTabChangeEvent } from "primereact/tabmenu";
import { useEffect, useState } from "react";
import { TbBinaryTree2 } from "react-icons/tb";
import { useLocation, useNavigate } from "react-router-dom";

import { useListCardsContext } from "./list-cards.context";

export function ListCards() {
  // THIS IS THE LOCAL DECLARATION
  const { getClientFeatures } = useUserIdentityContext();
  const clientFeatures = getClientFeatures();
  const navigate = useNavigate();
  const location = useLocation();
  const [tabActiveIndex, setTabActiveIndex] = useState(0);
  const items = [
    { label: "Campaign", icon: "pi pi-file-edit", path: "" },
    { label: "Activity", icon: "pi pi-chart-line", path: "activity" },
    { label: "Redeemed Items", icon: "pi pi-chart-line", path: "redeemed-items" },
    ...(clientFeatures?.featureFleetManagement
      ? [{ label: "Vehicles", icon: "pi pi-car", path: "vehicle" }]
      : []),
    ...(clientFeatures?.featureCoupon
      ? [{ label: "Coupons", icon: "pi pi-ticket", path: "available-coupons" }]
      : []),
    ...(clientFeatures?.featureReferral
      ? [{ label: "Referrals", icon: <TbBinaryTree2 />, path: "referrals" }]
      : []),
  ];

  const showSplash = StorageService.load("showsplash");
  const [splashScreens, setSplashScreens] = useState<GetSplashScreenModel[]>();
  const [splashDialog, setSplashDialog] = useState<boolean>(
    showSplash !== null ? Boolean(showSplash) : false,
  );
  const { isMobileMode } = useScreenSize();

  // THIS IS THE QUERY DECLARATION
  const handleGetApiSuccess = async (
    response: GetResponseSplashScreenModel,
  ) => {
    const _responseData = response?.data || [];
    if (_responseData.length > 0) {
      const updatedResponse = await Promise.all(
        _responseData.map(async (element: GetSplashScreenModel) => {
          if (!element?.image) {
            return { ...element };
          }
          const elementFile = await viewAsset(element?.image);
          const image = URL.createObjectURL(elementFile);
          return { ...element, image };
        }),
      );
      setSplashDialog(true);
      setSplashScreens(updatedResponse);
    } else {
      setSplashDialog(false);
    }
  };
  useQyGetSplashScreen(
    "",
    10,
    0,
    undefined,
    undefined,
    true,
    handleGetApiSuccess,
  );

  const { cardsElement, cardDetailsElement, actions, handleAction } =
    useListCardsContext();

  // THIS IS THE LOCAL RENDERS
  // THIS IS THE LOCAL DECLARATION
  useEffect(() => {
    const paths = location.pathname.split("/").filter((item) => !!item);

    if (paths.length === 1) {
      setTabActiveIndex(0);
      return;
    }

    let current = "";
    if (paths.length === 2) {
      current = paths[paths.length - 1];
    } else if (paths.length > 3) {
      current = paths[2];
    }

    const index = items.findIndex(item => item.path === current);
    setTabActiveIndex(index !== -1 ? index : 0);

  }, [location]);
  const handleTabChange = (e: TabMenuTabChangeEvent) => {
    const targetItem = items[e.index];
  
    if (targetItem) {
      navigate(targetItem.path);
    }

    setTabActiveIndex(e.index);
  };

  return (
    <div id="ListCards" className="customer">
      <HeaderContent title={<h1>Cards</h1>}>
        <div className="flex flex-between">
          <HeaderButton actions={actions} onAction={handleAction} />
        </div>
      </HeaderContent>
      <Dialog
        visible={splashDialog}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!splashDialog) return;
          setSplashDialog(false);
          StorageService.save("showsplash", false);
        }}
        maximized={isMobileMode}
        contentClassName="p-0 rounded-md"
        showHeader={false}
      >
        <div className="relative">
          <Button
            icon="pi pi-times"
            className="absolute right-4 top-4 p-2 align-center text-gray-400"
            rounded
            text
            onClick={() => {
              setSplashDialog(false);
              StorageService.save("showsplash", false);
            }}
          />
          <a href={splashScreens?.[0].link}>
            <img
              src={splashScreens?.[0].image}
              alt={splashScreens?.[0].description}
            />
          </a>
        </div>
      </Dialog>
      <div>
        {cardsElement}
        <TabMenu
          model={items}
          activeIndex={tabActiveIndex}
          onTabChange={handleTabChange}
        />
        {cardDetailsElement}
      </div>
    </div>
  );
}

export default ListCards;
